import {LastReadsTimetokensSchema} from '@/features/chat/services/chat.schema'
import {AvatarSchema} from '@/features/feed/services/feed.schema'
import {z} from 'zod'

export const enum REPRESENTATIVE_MODEL {
    FirstName = 'firstName',
    LastName = 'lastName',
    Email = 'email',
    Description = 'description',
    GenderID = 'genderId',
    InputPhoneNumber = 'testPhoneNumber',
    PhoneNumber = 'phoneNumber',
    PhoneCountryCode = 'phoneNumberCountry',
    PathLocation = 'avatarFileUploadId',
    RemoveAvatar = 'removeAvatar'
}

export const InvitationAgentAndRepsResponseSchema = z.object({
    // message: z.string(),
    // res: z.object({
    id: z.number(),
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
    phoneNumberCountry: z.string().nullable(),
    phoneNumber: z.string().nullable(),
    status: z.string(),
    expiresAt: z.string(),
    createdAt: z.string(),
    type: z.enum(['request', 'invitation']).optional(),
    agentId: z.number().optional()
    // })
})

export const HostChannelObjectSchema = z.object({
    id: z.number(),
    rookieId: z.number(),
    leaderId: z.number(),
    displayName: z.string(),
    lastReadsTimetokens: z.array(LastReadsTimetokensSchema).nullable()
})

export const TypeAttributesSchema = z.object({
    id: z.number(),
    isInfluencer: z.boolean(),
    agentRevenueShare: z.string(),
    minMorgiToOpenConnection: z.number().nullable()
})

export const CreatorSchema = z.object({
    id: z.number(),
    username: z.string(),
    type: z.string(),
    fullName: z.string(),
    isOnline: z.boolean(),
    avatar: AvatarSchema,
    typeAttributes: TypeAttributesSchema
})

export const RepresentedHostsSchema = z.object({
    id: z.number(),
    agentId: z.number(),
    representativeId: z.number(),
    rookieId: z.number(),
    creator: CreatorSchema,
    username: z.string().optional()
})

export const HostChannelSchema = z.record(z.number(), HostChannelObjectSchema)
